import AdminHomeSection1 from "./AdminHomeSection1";
import AdminHeader from "../Component/AdminHeader";
import { useEffect } from "react";
import { useNavigate } from "react-router";
export default function AdminDash() {
    const navigate = useNavigate();
    const token = `${window.localStorage.getItem("access")}`;
    const role = `${window.localStorage.getItem('role')}`;
    useEffect(() => {
        if ((token === '' || null) || role === 2) {
            navigate(`/Login`)
            return
        }
    }, [token]);
    return (
        <>
            <section className="profile-container bg-gray-100">
                <div className="container-fluid px-7">
                    <div className="row align-items-start">
                        <div className="col-xl-2">
                            <AdminHeader />
                        </div>
                        <div className="col-xl-10">
                            <div className="profile-content-area my-6 card card-body">
                                <div className="border-bottom mb-6 pb-6">
                                    <AdminHomeSection1 />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}